export const BaseHomeLayoutTemplate = `{{{sidebar}}}{{{content}}}{{{modal}}}`;
